import OrgContactTableColumn from "../../constants/OrgContactTableColumn";

export default [
    {id: OrgContactTableColumn.NAME.key, active: true},
    {id: OrgContactTableColumn.WEBSITE.key, active: true},
    {id: OrgContactTableColumn.SOCIAL_LINKS.key, active: true},
    {id: OrgContactTableColumn.TAGS.key, active: true},
]